import React from 'react';
import { useLocation, useParams } from '@thd-olt-component-react/router';
import Breadcrumbs from '../breadcrumbs/Breadcrumbs';
import { staticPageUrls } from '../../utils/consts';

const CardBreadcrumbs = () => {
  const { pathname } = useLocation();
  const { name } = useParams();
  const productName = name.replace(/-/g, ' ');
  const isThirdPartyCard = !productName?.toLowerCase().includes('home depot');

  const breadcrumbs = [
    staticPageUrls.landing,
    {
      name: productName,
      url: pathname
    }
  ];

  if (isThirdPartyCard) {
    breadcrumbs.splice(1, 0, staticPageUrls.thirdParty);
  }
  return <Breadcrumbs startFromHome breadcrumbs={breadcrumbs} />
}

export default CardBreadcrumbs;